var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.show)?_c('b-nav-item-dropdown',{attrs:{"text":_vm.text,"toggle-class":"nav-link-custom","right":""}},_vm._l((_vm.links),function(link){return _c('span',{key:'refercendata' + link.model},[(link.permission)?_c('b-dropdown-item',{attrs:{"to":link.route}},[_vm._v(_vm._s(link.name))]):_vm._e()],1)}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }